import React, { useState } from "react";
import "./BookSection.css";

const BookSection = () => {
  const [showReviews, setShowReviews] = useState(false);

  return (
    <div className="book-container" id="livres">
      <h2 className="section-title">Mon Livre</h2>

      <p className="book-intro">
        J&apos;ai toujours aimé écrire, alors, j&apos;ai décidé de publier mon propre livre.
        Il est principalement disponible en anglais, mais j&apos;espère qu&apos;il saura captiver
        tous ceux qui s&apos;y plongent.
      </p>

      {/* BOOK CARD */}
      <div className="book-card">
        <div className="book-left">
          <img
            src={require("../assets/images/61vCh9bquUL._AC_UF1000,1000_QL80_.jpg")}
            alt="Fictional Science Book Cover"
            className="book-image"
          />

          <div className="book-details">
            <h3 className="book-title">Fictional Science</h3>

            <p className="book-description">
              Have you ever gazed at the stars and wondered if there is life out there?
              How and why Stonehenge was built? About the presence of aliens on Earth?
              If mind transfers exist? How we could travel instantly from one place to another?
              Then again, are you worried about terrorism or nuclear disarmament?
            </p>

            <p className="book-description">
              If these thoughts intrigue you, follow the Beings who caused the Big Bang,
              came to Earth, and influenced Human evolution. Experience the journey of Beckires,
              a young girl rescued during the destruction of Atlantis, who becomes the Protector
              of Humans and the Keeper of the &quot;In Here, Out There&quot; portals.
            </p>

            <p className="book-description">
              As the world nears annihilation, Beckires uses her Seeker abilities to recruit
              a group of warriors to restore balance. Facing the greatest challenge of all –
              terrorism and nuclear disarmament – she and Bob Leboss create Fictional Science in Room #5.
              But when she falls in love, she loses her immortality.
              Will she still be able to save humanity from self-destruction?
            </p>
          </div>
        </div>

        <div className="buy-buttons">
          <a
            href="https://www.amazon.ca/Fictional-Science-Jacques-S%C3%A9guin-ebook/dp/B08RV9RG1B#customerReviews"
            target="_blank"
            rel="noopener noreferrer"
            className="buy-btn amazon"
          >
            Acheter sur Amazon
          </a>

          <a
            href="https://www.indigo.ca/en-ca/fictional-science/678ecd63-28c6-373c-8610-c281fa1c839e.html"
            target="_blank"
            rel="noopener noreferrer"
            className="buy-btn indigo"
          >
            Acheter sur Indigo
          </a>
        </div>
      </div>

      {/* REVIEWS BELOW */}
      <div className="reviews-below">
        <div className="reviews-header">
          <h3 className="reviews-title">Avis de lecteurs (2)</h3>

          <button
            type="button"
            className="reviews-toggle"
            onClick={() => setShowReviews((prev) => !prev)}
            aria-expanded={showReviews}
          >
            <span className={`arrow ${showReviews ? "open" : ""}`}>▾</span>
          </button>
        </div>

        <div className={`reviews-wrapper ${showReviews ? "open" : ""}`}>
          <div className="review-card">
            <p className="review-context">
              J’ai reçu cette lettre de Danielle Charlebois au sujet de <em>Fictional Science</em>.
              J’ai particulièrement apprécié cette éloge car bien que je lui a donné mon livre je ne
              croiyais pas qu’elle le lirait car elle n’est pas le genre à lire de la science fiction.
            </p>

            <blockquote className="review-quote">
              Bonsoir Jacques,{"\n\n"}
              Ces derniers jours, je me suis délectée à la lecture de « Fictional Science ». Quel plaisir pour le lecteur d’être
              transporté par cet imaginaire, de suivre les personnages (pour moi, page « V » fort utile comme référence au cours
              de la lecture 😉), de suivre l’action parfois sur le qui-vive, appréciant les teintes d’espoir, les pointes d’humour…
              merci pour les notions et le « vivre avec » sur le Parkinson… bien inséré dans l’histoire.{"\n\n"}
              Très heureuse d’avoir lu ce livre, satisfaite du dénouement, avec aussi un intérêt pour les pages 107 à 112.{"\n"}
              Un prochain livre en devenir?{"\n\n"}
              Agréable fin d’été,{"\n"}
              Salutations à Suzanne, la famille,{"\n"}
              Danielle😊
            </blockquote>

            <p className="review-author">— Danielle Charlebois</p>
          </div>

          <div className="review-card">
            <p className="review-context">
              Voici une lettre de Michelle Bourassa au sujet de mon livre <em>Fictional Science</em>.
              Je fus agréablement surpris de lire cette analyse de mon livre.
            </p>

            <blockquote className="review-quote">
              Bonjour Jacques,{"\n\n"}
              Après ton appel de bonne année, je me suis dit que tu me reparlais peut-être de ton roman pour une bonne raison.
              Alors, au lieu d&apos;attendre mon départ vers le sud, je l&apos;ai apporté en autocar quand j&apos;allais garder mes petits-fils
              à Montréal et je l&apos;ai lu en soirée, parfois même quand je me réveillais la nuit. Je viens d&apos;en terminer ma lecture.{"\n\n"}
              Te dire :{"\n"}
              - que j&apos;ai adoré,{"\n"}
              - que je voudrais que ces dix superhéros existent en ce moment,{"\n"}
              - que tu inventes une histoire comme si tu voyais venir ce qui est aujourd&apos;hui,{"\n"}
              - l&apos;amour vit et grandit en dépit de l&apos;insoutenable qui submerge la planète,{"\n"}
              - que les jeux, l&apos;humour, l&apos;affection, la solidarité co-existent et sont plus forts que tout,{"\n"}
              - et qu&apos;il suffit d&apos;inventer un univers parallèle - en nous - pour que tout redevienne possible.{"\n\n"}
              J&apos;ai été bouleversée par ta description du Parkinson.{"\n\n"}
              Quels beaux moments tu m&apos;as offerts. MERCI !!! MERCI !!!{"\n\n"}
              Avec toute mon affection,{"\n"}
              Michelle
            </blockquote>

            <p className="review-author">— Michelle Bourassa</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookSection;
